import { render, staticRenderFns } from "./UnusualSelect.vue?vue&type=template&id=38106874&scoped=true&"
import script from "./UnusualSelect.vue?vue&type=script&lang=js&"
export * from "./UnusualSelect.vue?vue&type=script&lang=js&"
import style0 from "./UnusualSelect.vue?vue&type=style&index=0&id=38106874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38106874",
  null
  
)

export default component.exports